import {
  IconButton,
  Label,
  Stack,
  Sticky,
  StickyPositionType,
  TooltipHost,
} from '@fluentui/react';
import React from 'react';
import { ColumnData } from './column.data';

interface ColumnsHeaderProps {
  columnsArray: ColumnData[];
}
export const ColumnsHeader: React.FC<ColumnsHeaderProps> = ({
  columnsArray,
}) => {
  const TOOLTIP_TEXT =
    'To override company exchange rates,enter price of 1 unit of home currency';
  return (
    <Sticky stickyPosition={StickyPositionType.Header}>
      <Stack
        horizontal
        tokens={{ childrenGap: 30 }}
        style={{
          marginLeft: 20,
        }}
      >
        {columnsArray.map((value, key) => {
          if (value.isVisible) {
            switch (value.key) {
              case 'exchangeRate':
              case 'spotRate':
                return (
                  <Stack
                    horizontal
                    horizontalAlign="start"
                    style={{
                      height: 30,
                      width: value.maxWidth,
                    }}
                  >
                    <TooltipHost content={TOOLTIP_TEXT}>
                      <IconButton iconProps={{ iconName: 'Info' }} />
                    </TooltipHost>
                    <Label key={key} style={{ flexWrap: 'nowrap' }}>
                      {value.name}
                    </Label>
                  </Stack>
                );
              default:
                return (
                  <Stack
                    style={{
                      height: 30,
                      width: value.maxWidth,
                    }}
                    key={key}
                    verticalAlign="center"
                  >
                    <Label key={key}>{value.name}</Label>
                  </Stack>
                );
            }
          } else return null;
        })}
      </Stack>
    </Sticky>
  );
};
